
import { createClient } from '@supabase/supabase-js';
import { Database } from './types';

const supabaseUrl = 'https://yhaavtybixfnsrfojnpg.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InloYWF2dHliaXhmbnNyZm9qbnBnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwMTkwNjUsImV4cCI6MjA1ODU5NTA2NX0.qVnklTA66NZISFjxJIbAJdfWDx0b5IoToXTwV5zi2xs';

// Create a single instance of the Supabase client to prevent duplicate instances
export const supabase = createClient<Database>(supabaseUrl, supabaseKey, {
  auth: {
    storage: localStorage, // Explicitly use localStorage
    persistSession: true,  // Ensure sessions persist
    autoRefreshToken: true, // Auto refresh tokens
    detectSessionInUrl: true, // Detect OAuth tokens in URL
  }
});
